import { phone, text, textArea } from '@unreserved-frontend-v2/ui/schema-form/utils'
import { ValueHash } from '@unreserved-frontend-v2/utils/types'
import useTranslation from 'next-translate/useTranslation'
import { useMemo } from 'react'
import { CreateResidentialListingOpenHouseInquiryInput } from '@unreserved-frontend-v2/api/generated/graphql/types'

export const formSection = {
  key: 'attend-open-house-form',
  title: '',
  className: '',
  numColumns: 8,
  fields: [
    text('firstName', 'listings:inquiries.first-name', 'md:col-span-4 col-span-8', true),
    text('lastName', 'listings:inquiries.last-name', 'md:col-span-4 col-span-8', true),
    phone('phoneNumber', 'listings:inquiries.phone', 'col-span-8', true),
    text('email', 'listings:inquiries.email', 'col-span-8', true),
    textArea('message', 'listings:inquiries.message', 'col-span-8'),
  ],
}

export const useErrorMessages = (): { errorMessages: ValueHash<string> } => {
  const { t } = useTranslation()

  return useMemo(() => {
    return {
      errorMessages: {
        firstName: `${t('listings:inquiries.first-name')} ${t('listings:inquiries.required')}`,
        lastName: `${t('listings:inquiries.last-name')} ${t('listings:inquiries.required')}`,
        email: `${t('listings:inquiries.email')} ${t('listings:inquiries.required')}`,
        phoneNumber: `${t('listings:inquiries.phone')} ${t('listings:inquiries.required')}`,
      },
    }
  }, [t])
}

export interface AttendOpenHouseFormData {
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
  message: string
}

export const mapAttendOpenHouseFormToApi = (
  data: AttendOpenHouseFormData,
  openHouseId: string
): CreateResidentialListingOpenHouseInquiryInput => {
  return {
    email: data.email,
    firstName: data.firstName,
    lastName: data.lastName,
    phoneNumber: data.phoneNumber,
    openHouseId,
    ...(data.message ? { message: data.message } : {}),
  }
}
